import { act_com } from '@lc/action/cardType/Common';
import { act_contract } from '@lc/action/cardType/Contract';
import { createCardContractVerbose } from '@lc/interface/card/contract/factory';
// import { ContractMeta } from '@lc/card/meta/ss/ContractMeta';
import { Contract } from '@lc/interface/card/contract/types';
import { GameState } from '@lc/interface/gameState/types';
import { act_player } from '@lc/interface/player/action';
import { getPlayerStateWithId } from '@lc/lib/player_helper';

export const getContractVerbose = (ContractMeta: Contract[]) => [
	createCardContractVerbose(
		// 7 chernobyl
		ContractMeta[0],
		(playerData: any, gameState: GameState) =>
			act_contract.chernobyl(playerData, gameState),
		(playerData: any, gameState: GameState) => {
			(act_com.gainCarbon(playerData, gameState),
				act_com.reduceFactoryCost(playerData, gameState));
		},
		(playerData: any, gameState: GameState) =>
			act_player.deleteFactory(
				getPlayerStateWithId(
					gameState.playerStateArray,
					playerData.playerId
				),
				2
			)
	),
	createCardContractVerbose(
		// 8 dubai
		ContractMeta[1],
		(playerData: any, gameState: GameState) =>
			act_contract.dubai(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.gainCarbon(playerData, gameState, 2),
		(playerData: any, gameState: GameState) =>
			act_player.deleteFactory(
				getPlayerStateWithId(
					gameState.playerStateArray,
					playerData.playerId
				)
			)
	),
	createCardContractVerbose(
		// 9 antiAeroslMusical
		ContractMeta[2],
		(playerData: any, gameState: GameState) =>
			act_com.gainCarbon(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_player.deleteFactory(
				getPlayerStateWithId(
					gameState.playerStateArray,
					playerData.playerId
				)
			)
	),
	createCardContractVerbose(
		// 10 generate & hibernate
		ContractMeta[3],
		(playerData: any, gameState: GameState) =>
			act_contract.generateAndHibernate(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.reduceFactoryCost(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_player.deleteFactory(
				getPlayerStateWithId(
					gameState.playerStateArray,
					playerData.playerId
				)
			)
	),
	createCardContractVerbose(
		// 11 triangle
		ContractMeta[4],
		(playerData: any, gameState: GameState) =>
			act_contract.triangleCondition(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.gainCarbon(playerData, gameState, 2),
		(playerData: any, gameState: GameState) =>
			act_contract.trianglePenalty(playerData, gameState)
	),
	createCardContractVerbose(
		// 12 stocking
		ContractMeta[5],
		(playerData: any, gameState: GameState) =>
			act_contract.stockingCondition(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.gainCarbon(playerData, gameState, 3),
		(playerData: any, gameState: GameState) =>
			act_contract.stockingPenalty(playerData, gameState)
	),
	createCardContractVerbose(
		// 13 town named after you
		ContractMeta[6],
		(playerData: any, gameState: GameState) =>
			act_contract.townCondition(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.reduceFactoryCost(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_contract.townPenalty(playerData, gameState)
	),
	createCardContractVerbose(
		// 14 scholarship
		ContractMeta[7],
		(playerData: any, gameState: GameState) =>
			act_contract.scholarshipCondition(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.reduceFactoryCost(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_contract.scholarshipPenalty(playerData, gameState)
	),
	createCardContractVerbose(
		// 15 chargesItself
		ContractMeta[8],
		(playerData: any, gameState: GameState) =>
			act_contract.chargesItself(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.rechargeAllBatteries(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_player.deleteBattery(
				getPlayerStateWithId(
					gameState.playerStateArray,
					playerData.playerId
				),
				2
			)
	),
	createCardContractVerbose(
		// 16 rcCar
		ContractMeta[9],
		(playerData: any, gameState: GameState) =>
			act_contract.rcCarCondition(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.reduceFactoryCost(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_contract.rcCarPenalty(playerData, gameState)
	),
	createCardContractVerbose(
		// 17 liberalTears
		ContractMeta[10],
		(playerData: any, gameState: GameState) =>
			act_contract.liberalTearsCondition(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_contract.liberalTearsFunding(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_player.deleteBattery(
				getPlayerStateWithId(
					gameState.playerStateArray,
					playerData.playerId
				),
				2
			)
	),
	createCardContractVerbose(
		// 18 workhorse
		ContractMeta[11],
		(playerData: any, gameState: GameState) =>
			act_contract.workhorseCondition(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.drawCards(playerData, gameState, 3),
		(playerData: any, gameState: GameState) =>
			act_contract.workhorsePenalty(playerData, gameState)
	),
	createCardContractVerbose(
		// 19 pyramids
		ContractMeta[12],
		(playerData: any, gameState: GameState) =>
			act_contract.pyramidCondition(playerData, gameState),
		(playerData: any, gameState: GameState) => {
			act_com.reduceFactoryCost(playerData, gameState);
			act_com.gainCarbon(playerData, gameState);
		},
		(playerData: any, gameState: GameState) => {
			const pState = getPlayerStateWithId(
				gameState.playerStateArray,
				playerData.playerId
			);
			const c = pState.energyColor;
			act_player.deleteFactory(pState);
			act_player.buyPR(pState, [c, c]);
		}
	),
	createCardContractVerbose(
		// 20 ac
		ContractMeta[13],
		(playerData: any, gameState: GameState) =>
			act_contract.acCondition(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.gainBatteryPrecharged(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_contract.acPenalty(playerData, gameState)
	),
	createCardContractVerbose(
		// 21 charitableDonation
		ContractMeta[14],
		(playerData: any, gameState: GameState) =>
			act_contract.charitableDonationCondition(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.gainCarbon(playerData, gameState, 2),
		(playerData: any, gameState: GameState) =>
			act_contract.charitableDonationPenalty(playerData, gameState)
	),
	createCardContractVerbose(
		// 22 greenLogo
		ContractMeta[15],
		(playerData: any, gameState: GameState) =>
			act_contract.greenLogoCondition(playerData, gameState),
		(playerData: any, gameState: GameState) => {
			const pState = getPlayerStateWithId(
				gameState.playerStateArray,
				playerData.playerId
			);
			const c = pState.energyColor;
			act_com.gainCarbon(playerData, gameState);
			act_player.buyPR(pState, [c, c]);
		},
		(playerData: any, gameState: GameState) =>
			act_com.swapFootprints(playerData, gameState)
	),
	createCardContractVerbose(
		// 23 ambiguousPatent
		ContractMeta[16],
		(playerData: any, gameState: GameState) =>
			act_com.gainCarbon(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState)
	),
	createCardContractVerbose(
		// 24 dinosaur
		ContractMeta[17],
		(playerData: any, gameState: GameState) =>
			act_contract.dinosaurCondition(playerData, gameState),
		(playerData: any, gameState: GameState) => {
			const pState = getPlayerStateWithId(
				gameState.playerStateArray,
				playerData.playerId
			);
			const c = pState.energyColor;
			act_player.buyPR(pState, [c, c]);
		},
		(playerData: any, gameState: GameState) =>
			act_contract.dinosaurPenalty(playerData, gameState)
	),
	createCardContractVerbose(
		// 25 rainyDay
		ContractMeta[18],
		(playerData: any, gameState: GameState) =>
			act_contract.rainyDayCondition(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.gainBattery(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_contract.rainyDayPenalty(playerData, gameState)
	),
	createCardContractVerbose(
		// 26 hashtag
		ContractMeta[19],
		(playerData: any, gameState: GameState) =>
			act_contract.hashtagCondition(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.reduceFactoryCost(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_contract.hashtagPenalty(playerData, gameState)
	),
	createCardContractVerbose(
		// 27 freezingPoint
		ContractMeta[20],
		(playerData: any, gameState: GameState) =>
			act_contract.freezingPointCondition(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_contract.freezingPointPenalty(playerData, gameState)
	),
	createCardContractVerbose(
		// 28 sickOfWinning
		ContractMeta[21],
		(playerData: any, gameState: GameState) =>
			act_contract.sickOfWinningCondition(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_contract.sickOfWinningFunding(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_contract.sickOfWinningPenalty(playerData, gameState)
	),
	createCardContractVerbose(
		// 29 centerfold
		ContractMeta[22],
		(playerData: any, gameState: GameState) =>
			act_contract.centerfoldCondition(playerData, gameState),
		(playerData: any, gameState: GameState) => {
			const pState = getPlayerStateWithId(
				gameState.playerStateArray,
				playerData.playerId
			);
			const c = pState.energyColor;
			act_player.buyPR(pState, [c, c]);
		},
		(playerData: any, gameState: GameState) =>
			act_contract.centerfoldPenalty(playerData, gameState)
	),
	createCardContractVerbose(
		// 30 lowestBidder
		ContractMeta[23],
		(playerData: any, gameState: GameState) =>
			act_contract.lowestBidderCondition(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_contract.lowestBidderPentaly(playerData, gameState)
	),
];
